import React, { FormEvent } from 'react'
import SiteConfig from '../../model/SiteConfig'
import { DataFeedComponent } from './DataFeed'
import { Form, ButtonGroup, Button, Card, Row, Col, Modal } from 'react-bootstrap'
import { FaSave, FaTrashAlt } from 'react-icons/fa'
import DataFeed from '../../model/DataFeed'
import TextEntry from '../Downtimes/TableCells/TextEntry'
import { loadSiteConfig } from '../../rest-api/SiteConfig-api'

interface StateProps {
  siteConfig: SiteConfig
}

interface DispatchProps {
  save: (siteConfig: SiteConfig) => void
  registerSolarGis: (siteApiKey: string, xml: string) => Promise<string>
}

interface State {
  siteConfig: SiteConfig
  showSolarGisRegistraction: boolean
  solarGisXML: string
  solarGisError: string
}

type Props = DispatchProps & StateProps

export class SiteConfigComponent extends React.Component<Props, State> {
  handleSubmit(event: FormEvent<Element>, siteConfig: SiteConfig) {
    const form = event.currentTarget as any
    if (form.checkValidity() === false) {
      event.stopPropagation()
    } else {
      this.props.save(siteConfig)
    }
    event.preventDefault()
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      siteConfig: props.siteConfig,
      showSolarGisRegistraction: false,
      solarGisXML: '',
      solarGisError: ''
    }

    this.latestSiteConfig(props.siteConfig.key);
  }

  latestSiteConfig = async (apiKey: string): Promise<void> => {
    let updatedConfig = await loadSiteConfig(apiKey);
    if (updatedConfig) {
      this.setState({
        siteConfig: {
          ...this.props.siteConfig,
          tenMinuteData: updatedConfig?.tenMinuteData,
          alarmData: updatedConfig?.alarmData,
          liveData: updatedConfig?.liveData
        }
      })
    }
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>): void {
    if (this.props.siteConfig !== previousProps.siteConfig) {
      this.setState({ siteConfig: this.props.siteConfig })
    }
  }

  showSolarGISDialog(show: boolean) {
    this.setState({ showSolarGisRegistraction: show })
  }

  registerForSolarGIS() {
    this.props
      .registerSolarGis(this.props.siteConfig.key, this.state.solarGisXML)
      .then(() =>
        this.setState({
          showSolarGisRegistraction: false,
          siteConfig: { ...this.state.siteConfig, solarGisEnabled: true }
        })
      )
      .catch(error => this.setState({ solarGisError: error }))
  }

  configHasUnsavedChanges(siteConfig: SiteConfig) {
    return siteConfig.liveDataHasUnsavedChanges || siteConfig.alarmDataHasUnsavedChanges || siteConfig.tenMinuteDataHasUnsavedChanges
  }

  public render() {
    const { siteConfig } = this.state
    return (
      <div>
        <Form
          noValidate
          validated={this.configHasUnsavedChanges(siteConfig)}
          onSubmit={(e: FormEvent<Element>) => this.handleSubmit(e, siteConfig)}
        >
          <DataFeedComponent
            type="Live data"
            dataFeed={siteConfig.liveData}
            hasUnsavedChanges={siteConfig.liveDataHasUnsavedChanges}
            dataFeedChanged={(dataFeed: DataFeed) =>
              this.setState({
                siteConfig: { ...siteConfig, liveData: dataFeed, liveDataHasUnsavedChanges: true }
              })
            }
          />
          <DataFeedComponent
            type="Alarm data"
            dataFeed={siteConfig.alarmData}
            hasUnsavedChanges={siteConfig.alarmDataHasUnsavedChanges}
            dataFeedChanged={(dataFeed: DataFeed) =>
              this.setState({
                siteConfig: { ...siteConfig, alarmData: dataFeed, alarmDataHasUnsavedChanges: true }
              })
            }
          />
          <DataFeedComponent
            type="10 minute data"
            dataFeed={siteConfig.tenMinuteData}
            hasUnsavedChanges={siteConfig.tenMinuteDataHasUnsavedChanges}
            dataFeedChanged={(dataFeed: DataFeed) =>
              this.setState({
                siteConfig: { ...siteConfig, tenMinuteData: dataFeed, tenMinuteDataHasUnsavedChanges: true }
              })
            }
          />
          <Card>
            <Card.Header style={{ backgroundColor: '#455560', color: 'white' }}>
              Solar GIS PV Spot data
            </Card.Header>
            <Card.Body>
                <Form.Group as={Row}>
                  <Col sm={2}>
                    <Form.Check
                      checked={siteConfig.solarGisEnabled}
                      disabled={true}
                      label="Enabled"
                    />
                  </Col>
                  {!!!siteConfig.solarGisEnabled && (
                    <Col sm={10}>
                      <Button onClick={() => this.showSolarGISDialog(true)}>
                        Register Site For Solar GIS Download
                      </Button>
                    </Col>
                  )}
                </Form.Group>
            </Card.Body>
          </Card>

          {this.configHasUnsavedChanges(siteConfig) && (
            <ButtonGroup className="align-items-center">
              <Button
                type="submit"
                {...(((siteConfig.validation && siteConfig.validation.length > 0) ||
                  (siteConfig.liveDataHasUnsavedChanges && siteConfig.liveData.validation && siteConfig.liveData.validation.length > 0) ||
                  (siteConfig.alarmDataHasUnsavedChanges && siteConfig.alarmData.validation && siteConfig.alarmData.validation.length > 0) ||
                  (siteConfig.tenMinuteDataHasUnsavedChanges && siteConfig.tenMinuteData.validation &&
                    siteConfig.tenMinuteData.validation.length > 0)) && {
                  disabled: true,
                  title: 'The site is not valid and cannot be saved'
                })}
              >
                <FaSave /> Save
              </Button>
              <Button onClick={() => this.setState({ siteConfig: this.props.siteConfig })}>
                <FaTrashAlt /> Cancel
              </Button>
            </ButtonGroup>
          )}
        </Form>
        <Modal
          show={this.state.showSolarGisRegistraction}
          onHide={() => this.showSolarGISDialog(false)}
          centered
          dialogClassName="availability-modal"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Enter XML User to Load Solar GIS Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Please enter the XML file defining how to download Solar GIS PV Spot data for this
              site.
            </p>
            <p>
              Documentation for the XML files can be found here{' '}
              <a href="https://wiki.solargis.com/display/public/WS+API+technical+documentation">
                https://wiki.solargis.com/display/public/WS+API+technical+documentation
              </a>
              .
            </p>
            <p>You should check this file with the Solar GIS api before registering it here.</p>
            <p>
              We have a limit on the number of sites that can be registered with Solar GIS, so
              please only register this site if you are sure you will need the data.
            </p>
            <TextEntry
              text={this.state.solarGisXML}
              onChange={(text: string) => this.setState({ solarGisXML: text })}
              placeholder="Enter XML"
            />
          </Modal.Body>
          <Modal.Footer>
            <p>{this.state.solarGisError}</p>
            <Button onClick={() => this.registerForSolarGIS()}>OK</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
